import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { PageLayout } from 'common/components/AppLayout/PageLayout.tsx';
import { TablePageTitle } from 'common/components/AppLayout/TablePage/TablePageTitle.tsx';
import { DEFAULT_BORDER_RADIUS } from 'theme/constants.ts';

export const BulkProvisioningTabContent = styled('div', { name: 'BulkProvisioningTabContent' })(
  ({ theme }) => ({
    borderRadius: DEFAULT_BORDER_RADIUS,
    borderTopLeftRadius: DEFAULT_BORDER_RADIUS,
    border: `1px solid ${theme.palette.border}`,
    overflow: 'hidden',
    height: `100%`,
    backgroundColor: theme.palette.white,
  }),
);

export const BulkProvisioningTab = styled('div', { name: 'BulkProvisioningTab' })(({ theme }) => ({
  height: `calc(100vh - ${theme.spacing(60)})`,
  paddingBottom: 20,
}));

const BulkProvisioningPageTitle = () => {
  const { t } = useTranslation();

  return <TablePageTitle>{t('bulkProvisioning.title')}</TablePageTitle>;
};

export const BulkProvisioningPageLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <PageLayout title={<BulkProvisioningPageTitle />}>
      <BulkProvisioningTab role="tabpanel" aria-label="Activity Log">
        <BulkProvisioningTabContent>{children}</BulkProvisioningTabContent>
      </BulkProvisioningTab>
    </PageLayout>
  );
};
